import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const MessageInput = ({ onSend, config }) => {
    const [input, setInput] = useState('');
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSend = () => {
        if (input.trim()) {
            onSend(input);
            setInput('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // prevent newline in textarea
            handleSend();
        }
    };

    const fontSize = screenWidth <= 1000 ? '35px' : '14px';
    const height = screenWidth <= 1000 ? '250px' : '100px';

    return (
        <>
            <style>
                {`
                    .message-input {
                        bottom: 0;
                        position: absolute;
                        width: 100%;
                        border-radius: 0px 0px 20px 20px;
                        border: none;
                        border-top: 1px solid #ccc;
                        background: #fff;
                        display: flex;
                        align-items: center;
                    }

                    .chat-input {
                        border: none;
                        padding: 5px 10px;
                        width: 100%;
                        background: transparent;
                        outline: none;
                        resize: none;
                    }

                    .chat-input:focus,
                    .chat-input:hover {
                        border: none;
                        outline: none;
                    }

                    .send-button {;
                        border: none;
                        cursor: pointer;
                        margin-right: 10px;
                        border-radius: 50%;
                    }
                `}
            </style>

            <div className="message-input" style={{ height }}>
                <textarea
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Type your message..."
                    className="chat-input"
                    rows="1"
                    style={{ fontSize, height }}
                ></textarea>
                <button onClick={handleSend} className="send-button" style={{ backgroundColor: config?.buttonColor || '#007bff', width: screenWidth <= 1000 ? '100px' : '50px', height: screenWidth <= 1000 ? '90px' : '45px' }}>
                    <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: screenWidth <= 1000 ? '50px' : '20px', color: '#fff' }} />
                </button>
            </div>
        </>
    );
};

export default MessageInput;
